import { RtkqSpin } from '@app/base';
import { AppointmentTypeTemplate, useLazyGetAllAppointmentTypeTemplatesQuery } from '@app/medical-record/api';
import { createEntireLoadOptionSource, Option } from '@webinex/antik';
import { useMemo } from 'react';

export interface AppointmentTypeTemplateLookupOption
  extends Option,
    Pick<AppointmentTypeTemplate, 'durationInMinutes'> {
  label: React.ReactNode;
  value: string;
}

function map(value: AppointmentTypeTemplate): AppointmentTypeTemplateLookupOption {
  return {
    label: value.name,
    value: value.id,
    _searchValue: value.name,
    durationInMinutes: value.durationInMinutes,
  };
}

export function useAppointmentTypeTemplateOptionSource() {
  const [fetchList, { currentData }] = useLazyGetAllAppointmentTypeTemplatesQuery();

  return useMemo(() => {
    return createEntireLoadOptionSource({
      fn: () =>
        fetchList(
          {
            [RtkqSpin]: false,
            filterRule: { operator: '=', fieldId: 'archived', value: false },
          },
          true,
        )
          .unwrap()
          .then((values) => values.map(map)),

      searchBy: '_searchValue',
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentData, fetchList]);
}
